var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('form-login',{staticClass:"col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 col-xxl-6 offset-xxl-3",attrs:{"csrf":_vm.csrf,"position":_vm.position,"links":_vm.links}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }